import { Select } from '@bynder/design-system';
import { useEffect, useState } from 'react';

export const InspectorSelect = ({ items, selectedValue, handleChange }) => {
  const [value, setValue] = useState(selectedValue);
  const selectedItem = items.find(i => i.value === value);

  const onChange = value => {
    setValue(value);
    handleChange(value);
  };

  useEffect(() => {
    setValue(selectedValue);
  }, [selectedValue]);

  return (
    <Select
      value={selectedItem?.value}
      label={selectedItem?.label}
      onChange={onChange}
      aria-labelledby="imageAction"
      icon={selectedItem?.icon}
    >
      {items.map(item => (
        <Select.Item value={item.value} icon={item.icon} key={item?.key}>
          {item.label}
        </Select.Item>
      ))}
    </Select>
  );
};
